import { useContext } from 'react';
import { BranchContext, BranchContextType } from '../context/BranchContext';

/**
 * Custom hook to access branch context
 * Provides branch state and branch switching functionality
 * 
 * @returns BranchContextType - Branch context with branches, activeBranch, and switchBranch method
 * @throws Error if used outside of BranchProvider
 * 
 * Usage:
 * ```tsx
 * const { branches, activeBranch, switchBranch, isLoading } = useBranch();
 * ```
 * 
 * Validates: Requirements 18.6
 */
export const useBranch = (): BranchContextType => {
  const context = useContext(BranchContext);

  if (context === undefined) {
    throw new Error('useBranch must be used within a BranchProvider');
  }

  return context;
};

export default useBranch;
